import { ajax } from '../../../services/helper'
class ApiService {

  

   getOrderVerificationData = (from,to,store_id,status,kitchen_id,city_id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/orders/list?from="+from+"&to="+to+"&store_id="+store_id+"&status="+status+"&kitchen_id="+kitchen_id+"&city_id="+city_id
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }
    getOrderVerificationDetails = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/menuTickets/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    getStoresCombolList = (kitchen_id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/stores/getCombo?kitchen_id="+kitchen_id
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


      getEmployeeById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employees/"+id+"/view"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

      getMenuDeatilsByMenuId = (menu_id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/menus/loadKitProductsCombo?menu_id="+menu_id
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


        
    
     addOrderVerification = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/menuTickets/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    
    editOrder = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/orders/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Order Verification/services/apiservices.js